import { createApp } from "vue";
import RecordingMap from "./RecordingMap.vue"
import store from "./store/store";



if (document.querySelector('#recording_map')) {
  const app = createApp(RecordingMap)
  app.use(store);
  app.mount('#recording_map');
}
